import { useToast } from '@ais-ui/ui-core';
import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useFetchPSSWithType, useUpdateAton } from '@ais-ui/api';
import {
  convertBackendValuesToVirtualAton,
  convertVirtualAtonValuesToBackend,
  mutateVirtualAtonFormSchema,
  MutateVirtualAtonFormValues,
} from './atonForm';
import { AtonVirtualDialog } from './AtonVirtualDialog';

import { useGetShareGroups } from '@ais-ui/websockets';
import { AtoN } from '@ais-ui/api-spec/config';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';
import { useAtonContext } from '../AtonContext';

export const EditVirtualAton = () => {
  const { messages } = useLocalization();
  const { mutate } = useUpdateAton();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();
  const { data: pss, isLoading: isLoadingPss } = useFetchPSSWithType('aton');
  const { setShowDialog, aton } = useAtonContext();

  const [hasLoadedValues, setHasLoadedValues] = useState<boolean>(false);

  const { toast } = useToast();
  const virtualForm = useForm<MutateVirtualAtonFormValues>({
    resolver: zodResolver(mutateVirtualAtonFormSchema),
  });

  useEffect(() => {
    // Check if both data sources have been loaded and set the dataLoaded state
    if (!isLoadingGroups && !isLoadingPss && aton) {
      const defaultValues = convertBackendValuesToVirtualAton(
        aton,
        groups,
        pss?.records
      );
      virtualForm.reset(defaultValues);
      setHasLoadedValues(true);
    }
  }, [aton, groups, isLoadingGroups, isLoadingPss, pss?.records, virtualForm]);

  const onUpdateVirtual = async (data: MutateVirtualAtonFormValues) => {
    if (!aton) {
      toast({
        title: messages.genericToastTitleError,
        description: messages.atonEditVirtualAtonGenericToastTitleError,
      });
      return;
    }

    const backendValues = convertVirtualAtonValuesToBackend(data);

    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'edit',
      'aton',
      setIsSubmitting,
      setShowDialog
    );

    mutate(
      {
        id: aton.uuid as string,
        aton: backendValues,
      },
      callBacks
    );
  };
  if (!hasLoadedValues) {
    return null;
  }

  return (
    <AtonVirtualDialog
      form={virtualForm}
      onSubmit={onUpdateVirtual}
      mutateType="edit"
      isSubmitting={isSubmitting}
      setShowOuterDialog={setShowDialog}
    />
  );
};
